import Vue from 'vue';
import Vuex from 'vuex';
import { OktaAuth } from '@okta/okta-auth-js';
import axios from 'axios';

Vue.use(Vuex);
const clientId = process.env.VUE_APP_CLIENT_ID;
const issuer = process.env.VUE_APP_ISSUER;
const oktaAuth = new OktaAuth({
  issuer: `${issuer}`,
  clientId: `${clientId}`,
  redirectUri: `${window.location.origin}`,
  scopes: ['openid', 'alliance_profile', 'apis.default'],
  pkce: true,
});

export default new Vuex.Store({
  state: {
    isAuthenticated_gdpr: false,
    isAuthenticated_dashboard: false,
    isAuthenticated: false,
    user_mail: null,
  },
  mutations: {
    auth_success_gdpr(state, payload) {
      state.isAuthenticated_gdpr = payload;
      state.isAuthenticated = payload;
    },
    auth_success_dashboard(state, payload) {
      state.isAuthenticated_dashboard = payload;
      state.isAuthenticated = payload;
      console.log(payload);
    },
    logout(state) {
      state.isAuthenticated_gdpr = false;
      state.isAuthenticated_dashboard = false;
      state.isAuthenticated = false;
    },
    user_mail(state, payload) {
      state.user_mail = payload;
    },
  },
  actions: {
    async login() {
      try {
        // Trigger Okta login
        await oktaAuth.signInWithRedirect();
      } catch (error) {
        console.error('Login Error:', error);
        // You might want to handle the login error appropriately
      }
    },
    async logout({ commit }) {
      try {
        // Trigger Okta logout
        await oktaAuth.signOut();
        commit('logout'); // Reset authentication state
        localStorage.clear();
      } catch (error) {
        console.error('Logout Error:', error);
        // Handle the logout error
      }
    },
    async checkAuthentication({ commit }) {
      await oktaAuth.handleRedirect();
      const token = await oktaAuth.getAccessToken();
      if (token) {
        axios.post('api/login', token)
          .then((response) => {
            axios.defaults.headers.common.Authorization = token;
            const mail = response.data.user;
            const authSuccessGdpr = response.data.is_authorized_gdpr;
            const authSuccessDashboard = response.data.is_authorized_dashboard;
            commit('user_mail', mail);
            commit('auth_success_gdpr', authSuccessGdpr);
            commit('auth_success_dashboard', authSuccessDashboard);
            if (authSuccessGdpr) {
              this.$router.push('/exclusion');
            } else if (authSuccessDashboard) {
              this.$router.push('/dashboard');
            }
          }).catch((error) => {
            console.log(error);
          });
      }
    },
    // You can add other actions here as needed
  },
  getters: {
    isAuthenticated_gdpr: (state) => state.isAuthenticated_gdpr,
    isAuthenticated_dashboard: (state) => state.isAuthenticated_dashboard,
    isAuthenticated: (state) => state.isAuthenticated,
    userMail: (state) => state.user_mail,
  },
});
